import {Component} from 'react';

const AppSimulationIcon = class extends Component {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox={"0 0 520 520"}
				fill={ this.props.fill ?? "currentColor" }
				stroke={ this.props.stroke ?? "none" }
				style={ this.props.style ?? {} }
			>
				<rect x="163.44" y="219.93" width="489.23" height="35.64" transform="translate(53.76 550.02) rotate(-71.62)" />
				<rect x="90.53" y="228.9" width="489.23" height="35.64" transform="translate(-31.34 443.89) rotate(-64.64)" />
				<rect x="10.02" y="241.42" width="489.23" height="35.64" transform="translate(-100.64 335.54) rotate(-57.64)" />
				<rect x="-76.78" y="256.29" width="489.23" height="35.64" transform="translate(-150.8 231.96) rotate(-50.99)" />
			</svg>
		);
	}
}

export default AppSimulationIcon;